/* global s, autoComplete */
/* eslint-disable no-console */
'use strict';

class Common {
	constructor(options) {
		this.defaults = {
			selectors: {
				update_states: {
					country_element_class: 'country-select',
					state_element_class: 'state-select',
					other_state_class: 'other-state',
					hide_element_class: 'd-none'
				},
				page_message: {
					page_message_container_id: 'page-message-container',
					page_message_animated_id: 'page-message-animated',
					page_message_text_id: 'page-message-text',
					page_message_close_id: 'page-message-close'
				},
				suggest_countries: {
					suggest_country_class: 'suggest-countries'
				},
				country_flags: {
					flag_wrapper_class: 'select-has-flag',
					flag_selector_class: 'has-flag',
					flag_holder_class: 'country-flag-holder',
					flag_name_prepend: 'flag-'
				},
				form_group: {
					wrapper_class: 'form-control',
					group_class: 'input-group',
					color_class: 'color-primary'
				},
				open_webcall_class: 'open-webcall',
				help_widget_class: 'widget_button_help'
			},
			state_change_trigger_focus: false,
			site_name: s.options.site_name,
			current_page: s.options.page_name
		};

		this.countryInput = document.querySelector('[data-country-search-input]');
		this.options = Object.assign(this.defaults, options);
		this.pageEvents();
	}

	pageEvents() {
		const _this = this;

		window.addEventListener('scroll', e => _this.updateHelpWidgetVisibility(e));
		window.addEventListener('resize', e => _this.updateHelpWidgetVisibility(e));
		_this.updateHelpWidgetVisibility();

		const page_message_close = document.getElementById(this.options.selectors.page_message.page_message_container_id);
		page_message_close?.addEventListener('click', () => {
			_this.hidePageMessage();
		});

		const country_fields = document.querySelectorAll(`.${_this.options.selectors.suggest_countries.suggest_country_class}`);
		country_fields?.forEach(country_field => {
			const currency_code = country_field.closest('.input-group')?.querySelector('.rates_change_currency')?.dataset?.selectedCurrency?.trim();
			_this.suggestCountries(country_field, currency_code ? {currency: currency_code} : {});
		});

		const all_forms = document.querySelectorAll('form:not(.enable-submit)');
		all_forms?.forEach(form => {
			form.addEventListener('submit', () => {
				const submits = form.querySelectorAll('[type="submit"]:not([name])');
				submits?.forEach(submit => submit.disabled = true);
			});
		});

		const all_flags = document.querySelectorAll(`.${_this.options.selectors.country_flags.flag_selector_class}`);
		all_flags?.forEach(all_flag => {
			all_flag.addEventListener('change', () => {
				_this.changeFlag(all_flag);
			});
		});

		if(this.countryInput && this.countryInput.dataset.countrySearchInput === '1'){
			const country_input = document.querySelector('#country-input');
			const observerOptions = { attributes: true, attributeFilter: ["data-country-code"] };

			const callback = (mutationList, observer) => {
				for(const mutation of mutationList){
					if (mutation.type === "attributes" && mutation.attributeName === "data-country-code") {
						_this.changeFlag(country_input);
					}
				}
			}

			const observer = new MutationObserver(callback);
			observer.observe(country_input, observerOptions);
		}

		const form_groups = document.querySelectorAll(`.${_this.options.selectors.form_group.wrapper_class}:not(.suggest-countries)`);
		form_groups?.forEach(form_group => {
			form_group.addEventListener('focusin', () => {
				form_group.closest(`.${_this.options.selectors.form_group.group_class}`)?.classList.add(_this.options.selectors.form_group.color_class);
			});
			form_group.addEventListener('focusout', () => {
				form_group.closest(`.${_this.options.selectors.form_group.group_class}`)?.classList.remove(_this.options.selectors.form_group.color_class);
			});
		});

		const webcall_triggers = document.querySelectorAll(`.${_this.options.selectors.open_webcall_class}`);
		webcall_triggers?.forEach(webcall_trigger => {
			webcall_trigger.addEventListener('click', () => {
				_this.openWebcall(webcall_trigger);
			});
		});
		const password_toggles = document.querySelectorAll('.toggle-password');
		password_toggles?.forEach(toggle => {
			toggle.addEventListener('click', e => {
				e.preventDefault();
				const use = toggle.querySelector('svg use');
				const password_input = toggle.closest('.input-group').querySelector('input');
				if (use.href.baseVal === '#svg_password-show') {
					use.href.baseVal = '#svg_password-hide';
					password_input.type = 'password';
				} else {
					use.href.baseVal = '#svg_password-show';
					password_input.type = 'text';
				}
			});
		});

		_this.setCopyBinds(document.querySelectorAll('.form-group .input-group-copy .btn-copy'));
	}

	setCopyBinds(copy_inputs) {
		copy_inputs?.forEach(copy_input => {
			copy_input.addEventListener('click', async () => {
				const input_copy = copy_input.closest('.input-group-copy').querySelector('.input-copy');
				let result;
				try {
					await navigator.clipboard.writeText(input_copy.value);
					result = true;
				} catch (e) {
					console.error('Could not copy to clipboard %o', e);
					result = false;
				}

				const form_group = copy_input.closest('.form-group');
				const feedback_holder = document.createElement('div');
				feedback_holder.classList.add('d-block');
				if (result) {
					form_group.querySelectorAll('.valid-feedback')?.forEach(e => e.remove());
					feedback_holder.classList.add('valid-feedback');
					feedback_holder.innerHTML = 'Copied to clipboard';
				} else {
					form_group.querySelectorAll('.invalid-feedback')?.forEach(e => e.remove());
					feedback_holder.classList.add('invalid-feedback');
					feedback_holder.innerHTML = 'Enable permissions of browsers does not support writing to clipboard';
				}
				form_group.appendChild(feedback_holder);
			})
		});
	}

	updateHelpWidgetVisibility() {
		let _this = this;
		const help_widget = document.querySelector(`.${_this.options.selectors.help_widget_class}`);

		if (help_widget) {
			const trigger = document.querySelector('.homepage-trustpilot-small');
			if (trigger && window.outerWidth <= 991 && window.pageYOffset <= trigger.offsetHeight) {
				help_widget.classList.remove('show');
			} else {
				help_widget.classList.add('show');
			}
		}
	}

	/**
	 * Update the flag on select elements according to the chosen option
	 *
	 * @param {Object}   element      JS element on which the flag should change
	 */

	changeFlag(element) {
		let _this = this;
		if (element && element.nodeName === 'SELECT') {
			let _selected_country = '';
			let _flag_holder;
			if (typeof element.options !== 'undefined' && element.options[element.selectedIndex].dataset.countryCode) {
				_selected_country = element.options[element.selectedIndex].dataset.countryCode;
			}
			if (element.previousElementSibling && element.previousElementSibling.classList.contains(_this.options.selectors.country_flags.flag_holder_class)) {
				_flag_holder = element.previousElementSibling;
			} else {
				_flag_holder = document.createElement('div');
				_flag_holder.classList.add(_this.options.selectors.country_flags.flag_holder_class);
				if (element.parentNode && element.parentNode.classList.contains(_this.options.selectors.country_flags.flag_wrapper_class)) {
					element.parentNode.insertBefore(_flag_holder, element.parentNode.childNodes[0]);
				}
			}
			for (let _i=0, _len = _flag_holder.classList.length;_i<_len;_i++) {
				let className = _flag_holder.classList[_i];
				if (className.startsWith(_this.options.selectors.country_flags.flag_name_prepend)) {
					_flag_holder.classList.remove(className);
				}
			}
			_flag_holder
				.classList
				.add(`${_this.options.selectors.country_flags.flag_name_prepend}${_selected_country.toUpperCase()}`);
				
		} else if(element && element.nodeName === 'INPUT'){
			let _selected_country = '';
			let _flag_holder;
			if (element.dataset.countryCode) {
				_selected_country = element.dataset.countryCode;
			} else {
				_flag_holder = element.previousElementSibling;
				_flag_holder.style.display = 'none';
			}
			if (element.previousElementSibling && element.previousElementSibling.classList.contains(_this.options.selectors.country_flags.flag_holder_class)) {
				_flag_holder = element.previousElementSibling;
			} else {
				_flag_holder = document.createElement('div');
				_flag_holder.classList.add(_this.options.selectors.country_flags.flag_holder_class);
				if (element.parentNode && element.parentNode.classList.contains(_this.options.selectors.country_flags.flag_wrapper_class)) {
					element.parentNode.insertBefore(_flag_holder, element.parentNode.childNodes[0]);
				}
			}
			for (let _i=0, _len = _flag_holder.classList.length;_i<_len;_i++) {
				let className = _flag_holder.classList[_i];
				if (className.startsWith(_this.options.selectors.country_flags.flag_name_prepend)) {
					_flag_holder.classList.remove(className);
				}
			}
			_flag_holder
				.classList
				.add(`${_this.options.selectors.country_flags.flag_name_prepend}${_selected_country.toUpperCase()}`);
			_flag_holder
				.style
				.zIndex = '4';
		}
	}

	/**
	 * Suggests countries on input. Options added via "data-" attributes. Country list taken from sell_countries object under the specific product
	 */

	suggestCountries(element, params = {}) {
		if (element) {
			if (element.dataset.suggestProduct) {
				let _product = element.dataset.suggestProduct;
				if(this.countryInput && this.countryInput.dataset.countrySearchInput === '1'){
					const sellCountries = s.options.sell_countries[_product];
					const sellCountryNames = sellCountries.map(country => country.name);

					if (sellCountries) {
						
						let _suggested_countries = sellCountries;
						s.options.page_autocompletes[sellCountryNames] = new autoComplete({
							minChars: 0,
							selector: element,
							menuClass: `countries-autocomplete-${_product}`,
							cache: 0,
							source(term, suggest) {
								term = term.toLowerCase();
								let _matches = [];
								for (let i=0;i<_suggested_countries.length;i++) {
									if (~_suggested_countries[i].name.toLowerCase().indexOf(term)) {
										_matches.push(_suggested_countries[i]);
									}
								}
								suggest(_matches);
							}, 
							onSelect(e, term) {
									element.setAttribute('data-country-name', term);
							}
						});
					}
				} else {
					if (s.options.sell_countries[_product]) {
						let _suggested_countries = s.options.sell_countries[_product];
						s.options.page_autocompletes[_product] = new autoComplete({
							minChars: 0,
							selector: element,
							menuClass: `countries-autocomplete-${_product}`,
							cache: 0,
							source(term, suggest) {
								term = term.toLowerCase();
								let _matches = [];
								for (let i=0;i<_suggested_countries.length;i++) {
									if (~_suggested_countries[i].toLowerCase().indexOf(term)) {
										_matches.push(_suggested_countries[i]);
									}
								}
								suggest(_matches);
							},
							onSelect(e, term) {
								let url = '/';
								url += (element.dataset.suggestLink ? s.trim(element.dataset.suggestLink, '/') : 'international-calls');
								url += '/';
								url += encodeURIComponent(term);
	
								window.location.href = s.url(url, params);
							}
						});
					}
				}
			}
		}
	}

	/**
	 * Adds the correct states/regions for a selected country. Input shown if no states/regions available
	 */

	updateStates() {
		let _this = this;
		let _selectors = this.options.selectors.update_states;
		let _country_selects = document.querySelectorAll(`.${_selectors.country_element_class}`);
		if (_country_selects) {
			for (let _i=0, _len = _country_selects.length;_i<_len;_i++) {
				let el = _country_selects[_i];
				el.addEventListener('change', function () {
					let _selected_country_value = el.options[el.selectedIndex].value;
					let _state_select_element;
					let _other_state_element;
					let _initial_state_value = '';
					let _states;
					Array.prototype.filter.call(el.closest('form'), function(child) {
						if (child.classList.contains(_selectors.state_element_class)) {
							_state_select_element = child;
						}
						if (child.classList.contains(_selectors.other_state_class)) {
							_other_state_element = child;
							_initial_state_value = child.value;
						}
					});
					if (_state_select_element && _other_state_element) {
						if (_selected_country_value === '') {
							_other_state_element.classList.add(_selectors.hide_element_class);
							_state_select_element.classList.add(_selectors.hide_element_class);
						} else {
							try {
								_states = s.options.all_states[_selected_country_value];
							} catch (e) {_states = {};}
							_state_select_element.selectedIndex = 0;
							_state_select_element.options.length = 1;
							if (_states) {
								let _us_state;
								let _world_state;
								try {
									_us_state = s.options.messages.SELECT_STATE_CHECKOUT;
								} catch (e) {_us_state = '';}
								try {
									_world_state = s.options.messages.SELECT_REGION;
								} catch (e) {_world_state = '';}
								_state_select_element.options[0].text =
									_selected_country_value === 'US' ? _us_state : _world_state;
								for (let _i = 0;_i < _states.length;_i++) {
									_state_select_element.options[_i + 1] = new Option(_states[_i][1], _states[_i][0]);
									if (_initial_state_value === _states[_i][0]) {
										_state_select_element.selectedIndex = _i + 1;
									}
								}
								_other_state_element.classList.add(_selectors.hide_element_class);
								_state_select_element.classList.remove(_selectors.hide_element_class);
								if (_this.options.state_change_trigger_focus) {
									_state_select_element.focus();
								}
								_this.options.state_change_trigger_focus = true;
							} else {
								_state_select_element.classList.add(_selectors.hide_element_class);
								_other_state_element.classList.remove(_selectors.hide_element_class);
								if (_this.options.state_change_trigger_focus) {
									_other_state_element.focus();
								}
								_this.options.state_change_trigger_focus = true;
							}
						}
					}
				});
				try {
					el.dispatchEvent(new Event('change', {'cancelable': true}));
				} catch (err) {
					let event = document.createEvent('HTMLEvents');
					event.initEvent('change', true, false);
					el.dispatchEvent(event);
				}
			}
		}
	}

	/**
	 * Shows a page notification message. Slides under the header
	 *
	 * If multiple messages. they will be appended after each other to prevent having multiple message notifications overlapping
	 *
	 * @param {Object/string}   message           The text to be displayed. can handle multiple messages.
	 * @param {string}            message_type      Message background color is based on the type
	 * @param {int}            duration          How long the message will be shown. Default is 10s ( 10000 ms )
	 *
	 */

	showPageMessage(message, message_type, duration = 10000) {
		let _selectors = this.options.selectors.page_message;
		let _message_container = document.getElementById(_selectors.page_message_container_id);
		if (_message_container && message) {
			_message_container.className = '';
			_message_container.innerHTML = '';
			if (typeof message_type === 'undefined') {
				message_type = 'info';
				if (message_type === 'status_error')
					message_type = 'error';
				if (message_type === 'status_notice')
					message_type = 'info';
				if (message_type === 'status_warning')
					message_type = 'warning';
				if (message_type === 'status_success')
					message_type = 'success';
			}
			_message_container.classList.add(`bg-${message_type}`);
			let _container_el = document.createElement('div');
			_container_el.classList.add('container', 'drop-down-message', 'cursor-pointer');
			_container_el.id = _selectors.page_message_animated_id;
			let _row_el = document.createElement('div');
			_row_el.classList.add('row');
			let _parent_el = document.createElement('div');
			_parent_el.classList.add('col-12', 'py-10', 'color-white', 'd-flex', 'justify-content-between');
			let _close_message_el = document.createElement('div');
			_close_message_el.classList.add('d-flex', 'align-items-center', 'fs-16');
			_close_message_el.innerHTML = '&#10799';
			let _page_message_el = document.createElement('div');
			_page_message_el.id = _selectors.page_message_text_id;
			_close_message_el.classList.add('d-flex', 'align-items-center');
			if (typeof message === 'object') {
				Object.keys(message).forEach(function (key) {
					_page_message_el.innerHTML += message[key] + '<br>';
				});
			} else {
				_page_message_el.innerHTML = message;
			}
			_parent_el.append(_page_message_el);
			_parent_el.append(_close_message_el);
			_row_el.append(_parent_el);
			_container_el.append(_row_el);
			_message_container.innerHTML = _container_el.outerHTML;
			if (document.getElementById(_selectors.page_message_close_id)) {
				document.getElementById(_selectors.page_message_close_id).addEventListener('click', this.hidePageMessage);
			}
			clearTimeout(s.options.page_timers.page_message_animation);
			s.options.page_timers.page_message_animation = setTimeout(() => {
				if (document.getElementById(_selectors.page_message_animated_id)) {
					document.getElementById(_selectors.page_message_animated_id).classList.add('show');
				}
			}, 100);
			if (typeof duration === 'undefined') {
				duration = 10000;
			}
			if (duration !== 0) {
				clearTimeout(s.options.page_timers.page_message);
				s.options.page_timers.page_message = setTimeout(() => {
					this.hidePageMessage();
				}, duration);
			}
		}
	}

	/**
	 * Hides the page message. Automatically called after a certain time ( 10s by default ) or when the close button is clicked
	 */

	hidePageMessage() {
		let _selectors = this.options.selectors.page_message;
		let _message_container = document.getElementById(_selectors.page_message_container_id);
		if (_message_container) {
			if (document.getElementById(_selectors.page_message_animated_id)) {
				document.getElementById(_selectors.page_message_animated_id).classList.remove('show');
			}
			s.options.page_timers.page_message_animation = setTimeout(() => {
				_message_container.className = '';
				_message_container.innerHTML = '';
				clearTimeout(s.options.page_timers.page_message_animation);
			}, 1000);
		}
		clearTimeout(s.options.page_timers.page_message);
	}

	/**
	 * Returns the CC type
	 *
	 * @param {string}   val      CC number
	 *
	 * @return {string}  If matched, returns the CC type
	 */


	cardType(val) {
		let _type = '';
		if (val && val.length > 1) {
			if (val.match(/^2[2-7]/) || val.match(/^5[1-5]/)) {
				_type = 'mastercard';
			} else if (val.match(/^3[47]/)) {
				_type = 'american_express';
			} else if (val.match(/^6(011|4[4-9]|5)/)) {
				_type = 'discover';
			} else if (val.match(/^(2131|1800|35)/)) {
				_type = 'jcb';
			} else if (val.match(/^4/)) {
				_type = 'visa';
			}
		}

		return _type;
	}

	/**
	 * Returns the CC SVG Icon
	 *
	 * @param {string}   val      CC number
	 *
	 * @return           If matched, returns the CC icon
	 */

	cardIcon(val) {
		let _icon = '';
		if ( val.length > 1) {
			let _type = this.cardType(val);
			if (_type === 'mastercard') {
				_icon = s.svg('p_mastercard', '0 0 72 36');
			} else if (_type === 'american_express') {
				_icon = s.svg('p_american_express', '0 0 72 36');
			} else if (_type === 'discover') {
				_icon = s.svg('p_discover', '0 0 72 36');
			} else if (_type === 'jcb') {
				_icon = s.svg('p_jcb', '0 0 72 36');
			} else if (_type === 'visa') {
				_icon = s.svg('p_visa', '0 0 72 36');
			} else if (_type === 'china_union_pay') {
				_icon = s.svg('p_china_union_pay', '0 0 72 36');
			}
		}

		return _icon;
	}

	/**
	 * Creates a cookie
	 *
	 * @param {string}   name       Cookie name
	 * @param {string}   value      Cookie value
	 * @param {int}      days       Validity in days
	 *
	 */

	createCookie(name, value, days) {
		let expires;

		if (days) {
			let date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toGMTString();
		} else {
			expires = '';
		}
		document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/; Secure';
	}

	/**
	 * Reads a cookie
	 *
	 * @param {string}   name       Cookie name
	 *
	 */

	readCookie(name) {
		let nameEQ = encodeURIComponent(name) + '=';
		let ca = document.cookie.split(';');
		for (let i = 0;i < ca.length;i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
		}

		return null;
	}

	/**
	 * Removes a cookie
	 *
	 * @param {string}   name       Cookie name
	 *
	 */

	eraseCookie(name) {
		this.createCookie(name, '', -1);
	}

	/**
	 * Opens the WebCall popup
	 *
	 * @param {Object}   element           The Element that requested
	 * @param {Object}   optional_params   Optional URL Params
	 *
	 */

	openWebcall(element, optional_params = {}) {
		this.popitup(
			s.url('/account/webcall', optional_params),
			'Web Call',
			'width=373,height=645,scrollbars=no'
		);
	}

	/**
	 * Opens a popup
	 *
	 * @param {string}   url           URL to be opened
	 * @param {string}   name          Window Name
	 * @param {string}   properties    Window Properties
	 *
	 */

	popitup(url, name, properties) {
		if (!name)
			name = 'default_popup';
		if (!properties)
			properties = '';

		let new_window = window.open(url, name, properties);
		if (window.focus)
			new_window.focus();

		return false;
	}

	/**
	 * Scroll to an anchor to prevent the jumping behaviour
	 *
	 * @param {string}   id           ID of the element to scroll to
	 * @param {int}   offset       Optional Top offset
	 *
	 */

	scrollToAnchor(id, offset = 120) {
		//console.log('scrollToAnchor(%o, %o)', id, offset);
		id = id.replace('#', '');
		const _target = document.getElementById(id);
		const _top_position = _target.getBoundingClientRect().top + window.pageYOffset;
		window.scrollTo({top: _top_position - offset, behavior: 'smooth'});
	}

	/**
	 * Display the browser Notifications Permission popup
	 * If the permission is granted, or was already granted,
	 * call loadNotificationsBrowserScripts that loads the js files required for the notification functionality
	 *
	 * @param {Object}   options          Options for the NotificationsBrowser class
	 * @param {boolean}  force            Show the permission when triggered by a customer
	 *
	 */

	requireNotificationsBrowserPermission(options, force) {
		let _this = this;
		if ('Notification' in window && 'serviceWorker' in navigator) {
			if (Notification.permission === 'granted') {
				_this.loadNotificationsBrowserScripts(options);
			} else if (Notification.permission === 'denied') {
				this.triggerNotificationsNotActive();
			} else {
				if (force || (!window.localStorage.getItem('activeBrowser') || window.localStorage.getItem('activeBrowser') === '1')) {
					Notification.requestPermission().then((permission) => {
						console.log('permission: ', permission);
						/*
							Uncomment this when requiring permission from a user generated event.
							Currently Firefox skips this and chrome doesn't so we get mixed results on different browsers
							if (permission === 'granted') {
								_this.loadNotificationsBrowserScripts(options);
							} else {
								console.log('Unable to get permission to notify.');
							}
						 */
					});
				}

				// Remove this when permission is no longer required on load - the permission currently changes twice on load
				if ('permissions' in navigator) {
					navigator.permissions.query({name:'notifications'}).then(function(status) {
						status.onchange = function() {
							console.log('permission status changed: ' + status.state);
							if (status.state === 'granted') {
								_this.loadNotificationsBrowserScripts(options);
							}
						};
					});
				}
			}
		} else {
			this.triggerNotificationsNotActive();

			if (!('Notification' in window)) {
				console.log('notification not supported');
			}
			if (!('serviceWorker' in navigator)) {
				console.log('serviceworker not supported');
			}
		}
	}

	/**
	 * Loads the js files required for the notification functionality only if the permission is already granted
	 * Ref: FOOTERSCRIPTDEPENDENCIES
	 *
	 * @param {Object}   options          Options for the NotificationsBrowser class
	 *
	 */

	loadNotificationsBrowserScripts(options) {
		if ('Notification' in window && 'serviceWorker' in navigator) {
			if (Notification.permission === 'granted') {
				if (typeof firebase === 'undefined') {
					s.loadScript('//cdn.jsdelivr.net/npm/firebase@6.3.1/firebase-app.js', {
						'integrity': 'sha256-2aeGmdeWAhwbrUCoX38QiJKwwmBISj0IGuS/5PwcUbs=',
						'crossorigin': 'anonymous'
					})
						.then(() => {
							s.loadScript('//cdn.jsdelivr.net/npm/firebase@6.3.1/firebase-messaging.js', {
								'integrity': 'sha256-nB4wIQN6tiwOHhagiCkKJXpKOxdpyguWol6OW0pGhxI=',
								'crossorigin': 'anonymous'
							})
								.then(() => {
									s.loadScript('//cdn.jsdelivr.net/npm/idb-keyval@3.2.0/dist/idb-keyval-iife.min.js', {
										'integrity': 'sha256-8QyjvrI3bt7lxio4xChrepmn4WL8mbIB4pUI1RYKxh0=',
										'crossorigin': 'anonymous'
									})
										.then(() => {
											s.loadScript(s.url('/js/notifications_browser.min.js'))
												.then(() => {
													try {
														s.notifications_browser = new NotificationsBrowser(options ? options : {});
													} catch (error) {
														console.log('notifications error: ', error);
														this.triggerNotificationsNotActive;
													}
												})
												.catch(() => {
													console.error('Loading failed for notifications_browser.js');
												});
										})
										.catch(() => {
											console.error('Loading failed for idb-keyval.js');
										});
								})
								.catch(() => {
									console.error('Loading failed for firebase-messaging.js');
								});
						})
						.catch(() => {
							console.error('Loading failed for firebase-app.js');
						});
				} else {
					s.notifications_browser.processCurrentToken(true);
				}
			}
		} else {
			this.triggerNotificationsNotActive();

			if (!('Notification' in window)) {
				console.log('notification not supported');
			}
			if (!('serviceWorker' in navigator)) {
				console.log('serviceworker not supported');
			}
		}
	}

	/**
	 * Make the required adjustments on the page in case the Browser Notifications
	 * functionality encountered an error or not available on the browser
	 *
	 */

	triggerNotificationsNotActive() {
		if (document.querySelector('#notification-subcategory-web_push')
			&& document.querySelector('#web_push-parent-toggle')
		) {
			document.querySelector('#notification-subcategory-web_push').classList.add('category-open');
			document.querySelector('#web_push-parent-toggle').style.display = 'none';
		}
	}

	closeMenuHelpSection () {
		if (s.options.page_ajax.header_contact_form) {
			s.options.page_ajax.header_contact_form.abort();
		}

		$('#contact-container').SmoothSlideUp();

		let helpCenterBtn = $('.help-center-btn');
		helpCenterBtn.find('[data-name=\'default\']').removeClass('d-none');
		helpCenterBtn.find('[data-name=\'close\']').addClass('d-none');
	}

	closeMenuLoginRegisterSection () {
		let loginRegContainer = $('#login-register-container');
		let loginRegBtn = document.getElementById('login-register-menu-btn');


		if (loginRegContainer) {
			loginRegContainer.removeClass('active');
			loginRegContainer.SmoothSlideUp();
		}

		if (loginRegBtn) {
			loginRegBtn.classList.remove('active', 'hover-active');
		}
	}

	closeMobileMenu () {
		let navbar = document.querySelectorAll('.navbar-kc')[0];
		let mobileMenu = $(document.getElementById('mobile-menu'));
		let body = $('body,html');

		navbar.classList.remove('active');
		mobileMenu.find('.icon-menu-hamburger')[0].classList.remove('d-none');
		mobileMenu.find('.icon-menu-close')[0].classList.add('d-none');
		body.removeClass('no-scroll-mobile');

		//ios fix for closing mobile menu
		if (s.options.is_iOS) {
			body.removeClass('mobile-position-fixed-width100');
		}
	}

	// Remaining Timer for banners. Uses jQuery. Would be nice if it would use JS only
	remaining_timer(timer_holder) {
		let _this = this;
		let _current_date = new Date();
		let _start_date = new Date(timer_holder.attr('data-start_date_offer'));
		let _end_date = new Date(timer_holder.attr('data-end_date_offer'));

		let start_holder = timer_holder.find('._banner_timer_start');
		let end_holder = timer_holder.find('._banner_timer_end');

		if (_start_date && start_holder.length > 0) {
			let start_trigger = 259200;
			let diff_start = Math.floor((_start_date - _current_date) / 1000) + '';

			if (diff_start >= 0 && diff_start <= start_trigger) {
				start_holder.find('._timer').text(diff_start.toHMS());
				start_holder.removeClass('none');
			} else
				start_holder.addClass('none');
		}

		if (_end_date && end_holder.length > 0) {
			let end_trigger = 259200;
			let diff_end = Math.floor((_end_date - _current_date) / 1000) + '';

			if (diff_end >= 0 && diff_end <= end_trigger) {
				end_holder.find('._timer').text(diff_end.toHMS());
				end_holder.removeClass('none');
			} else
				end_holder.addClass('none');
		}

		if (_start_date && start_holder.length > 0 || _end_date && end_holder.length > 0) {
			setTimeout(function() {
				_this.remaining_timer(timer_holder);
			}, 1000);
		}
	}

	getSecurityFields(original_uri, token_value, nothing_name) {
		let has_token = false;
		let has_nothing = false;
		let has_snowman = false;
		let security_fields = [];
		let uri = original_uri.split('&');

		uri.forEach((attributes) => {
			attributes = attributes.split('=');
			if (attributes[0] === '_token' && decodeURIComponent(attributes[1]) === token_value) {
				has_token = true;
			}
			if (attributes[0] === nothing_name && attributes[1] === '') {
				has_nothing = true;
			}
			if (attributes[0] === '_snowman' && decodeURIComponent(attributes[1]) === '☃') {
				has_snowman = true;
			}
		});

		if (!has_token) {
			security_fields.push('_token=' + token_value);
		}
		if (!has_nothing) {
			security_fields.push(nothing_name + '=');
		}
		if (!has_snowman) {
			security_fields.push('_snowman=☃');
		}

		if (original_uri.length > 0) {
			original_uri += '&';
		}

		if (security_fields.length !== 0) {
			//console.log('adding needed fields');
			original_uri += encodeURI(security_fields.join('&'));
		}

		return original_uri;
	}

	/**
	 * Return the template name for a specific A/B test. In case the test is not valid on the store, returns null
	 *
	 * @param {string}   abtest             A/B test name
	 *
	 * @return {string}                     The template name if the test is valid
	 *
	 */
	getABTestTemplate(abtest) {
		let _template_name = null;
		if (abtest && typeof s.options.ab_tests !== 'undefined') {
			if (abtest in s.options.ab_tests) {
				if (s.options.ab_tests[abtest]['variation_name'] !== 'undefined') {
					_template_name = s.options.ab_tests[abtest]['variation_name'];
				}
			}
		}

		return _template_name;
	}

	init_help_center_widget(parent, page_name) {
		let _that = this;
		let help_widget_class = document.querySelector('.help_widget');
		if (help_widget_class) {
			help_widget_class.addEventListener('click', (_variable_name, _vars) => {
				if (window.outerWidth < 768) {
					return true;
				}
				_variable_name.preventDefault();

				let close_button = parent.querySelector('.close_widget');
				if (close_button) {
					close_button.addEventListener('click', (e) => {
						e.preventDefault();
						parent.querySelector('.widget_form_holder').classList.add('hidden');
						parent.querySelector('#hw_show_form').classList.remove('hidden');
					});
				}

				if (window.outerWidth < 768) {
					window.location = s.url('/help_center');
				} else {
					if (help_widget_class.id !== 'hw_toggle_state') {
						let c = document.createElement('div');
						c.classList.add('text-center', 'p-10');
						let widget_holder = parent.querySelector('.widget_form_holder');
						widget_holder.classList.remove('d-none');
						help_widget_class.classList.add('help_widget_active', 'close_button');

						help_widget_class.querySelector('.question-mark').classList.add('close_button');
						help_widget_class.id = 'hw_toggle_state';
						$.getScript(s.url('/js/help_center_widget.min.js'))
							.always(function (data, textStatus, jqxhr) {
								if (jqxhr.status === 200) {
									try {
										var help_widget = new HelpWidget({parent: parent, page_name: page_name});
									} catch (error) {
										console.log('Help Center Widget Error :  ' + error);
										_that.showHelpCenterError(parent, 'SOCIAL_LOGIN_ERROR');
									}
								} else {
									_that.showHelpCenterError(parent, 'SOCIAL_LOGIN_ERROR');
								}

							});
					}
				}
			});
		}
		if (window.localStorage !== null) {
			if (window.localStorage.getItem('question_id') !== null && window.outerWidth > 768) {
				$('.help_widget').trigger('click');
			}
		}
	}
	showHelpCenterError(parent, text_variable) {
		let answer_holder = parent.querySelector('#answer_holder');
		let error = document.createElement('div');
		let error_text = document.createElement('p');
		error_text.append(document.createTextNode(s.it(text_variable)));
		error.classList.add('p-15');
		error.appendChild(error_text);
		answer_holder.append(error);
	}

	fetcher(request, opts = {}) {
		//console.log('fetcher(%o, %o)', request, opts);
		if (opts.method.toLowerCase() === 'post') {
			if (!opts.body.has('_token')) {
				opts.body.append('_token', document.querySelector('form input[name=_token]')?.value);
			}

			const nothing_name = document.querySelector('form input[name^=_nothing_]')?.getAttribute('name');
			if (!opts.body.has(nothing_name)) {
				opts.body.append(nothing_name, '');
			}

			if (!opts.body.has('_snowman')) {
				opts.body.append('_snowman', '☃');
			}
		}

		const headers = {
			'X-Requested-With': 'XMLHttpRequest',
		};
		opts.headers = { ...headers, ...opts.headers };

		const controller = new AbortController();
		const signal = controller.signal;

		return {
			abort: () => controller.abort(),
			ready: (async () => {
				try {
					//console.log('fetch(%o, %o)', request, opts, signal);
					const result = await fetch(request, {...opts, signal});
					return await result.json();
				} catch (e) {
					if (e.name !== 'AbortError') {
						console.error('fetch error %o', e);
						throw new Error(e);
					}
				}
			})()
		};
	}

	submitForm(action, fields = []) {
		const form = document.createElement('form');
		form.action = action;
		form.method = 'post';

		const form_security_fields = get_form_security_fields();
		for (let name in form_security_fields) {
			const field = document.createElement('input');
			field.type = 'hidden';
			field.name = name;
			field.value = form_security_fields[name];
			form.appendChild(field);
		}

		fields.forEach(field => {
			const i_field = document.createElement('input');
			i_field.type = field.type;
			i_field.name = field.name;
			i_field.value = field.value;
			form.appendChild(i_field);
		});

		document.querySelector('body').appendChild(form);
		form.submit();
	}

	formDataToObject(form_data) {
		var object = {};
		form_data.forEach((value, key) => object[key] = value);
		return object
	}

	logEvent(event, data) {
		try {
			const form_data = new FormData();
			form_data.append('action', 'log_event');
			form_data.append('event', event);
			form_data.append('data', JSON.stringify(data));
			const fetch = s.common.fetcher(
				s.url('/account_process_checkout'),
				{
					method: 'post',
					body: form_data,
				}
			);
			return fetch.ready;
		} catch (e) {
			console.error(`Logging failed for ${event}: ${e.message}`);
		}
	}
}
